import React, {useEffect, useState} from 'react';
import {SHOPIFY_BULK_OPERATION_FIELDS_LIST} from "../../constants/shopify.constant";
import _ from "lodash";
import {appConfig} from "../../../firebase/client-app";
import {searchPods} from "../../../pod/services/pod-data-service";
import {searchThemes} from "../../../theme/services/theme-data-service";
import {searchDesigns} from "../../../design/services/design-data-service";
import {DEFAULT_DESIGN_DASHBOARD_TAB} from "../../../design/constants/design.constant";
import ShowEmptyListMessage from "../../../design/components/common/show-empty-list-message";
import {prepareDesignVariantLabel} from "../../../design/utils/design-variant-util";
import {searchShopifyBulkOperations} from "../../services/shopify-bulk-operation-data-service";
import {getShopifyProductsSyncStatus, syncShopifyProducts} from "../../../common/services/cloud-function-service";
import ShowProgressSpinner from "../../../common/ui/show-progress-spinner";
import CopyDataToClipboard from "../../../common/ui/copy-data-to-clipboard";

const ShopifyBulkOperationList = () => {
    const [initialStep, setInitialStep] = useState(true);
    const [bulkOperationsList, setBulkOperationsList] = useState(null);
    const [filterCriteria, setFilterCriteria] = useState(null);
    const [dataFetchInProgress, setDataFetchInProgress] = useState(true);

    useEffect(() => {
        getShopifyBulkOperationList();
        setInitialStep(false);
    }, [initialStep]);

    const getShopifyBulkOperationList = async () => {
        setDataFetchInProgress(true);

        const searchCriteriaList = [
            /*{
                field: 'dataType',
                condition: '==',
                value: 'Products'
            },*/
        ];
        const bulkOperationListResult = await searchShopifyBulkOperations(searchCriteriaList, 30);

        // console.log('bulkOperationListResult', bulkOperationListResult)

        setBulkOperationsList(_.orderBy(bulkOperationListResult, ['id'], ['desc']));
        setDataFetchInProgress(false);
    }

    const startProductsSyncProcess = async () => {
        setDataFetchInProgress(true);
        const response = await syncShopifyProducts();

        await getShopifyBulkOperationList();
        setDataFetchInProgress(false);
    }

    const getLatestBulkOperationStatus = async () => {
        setDataFetchInProgress(true);
        const response = await getShopifyProductsSyncStatus();

        await getShopifyBulkOperationList();
        setDataFetchInProgress(false);
    }

    const refreshShopifyBulkOperationList = async () => {
        await getShopifyBulkOperationList();
    }

    return (
        <>
            <div className="flex justify-start">
                <div className="w-full mt-2 flex justify-between">

                    <div className="flex items-center text-lg font-bold text-gray-500">
                        Shopify Bulk Operations
                    </div>

                    <div className="mr-4">
                        <ShowProgressSpinner dataFetchInProgress={dataFetchInProgress}/>
                    </div>

                    <div className="flex justify-end">

                        <div className="">
                            <button
                                className="button-green-outline px-4 py-2 flex items-center justify-center"
                                onClick={refreshShopifyBulkOperationList}>
                                <span>Refresh</span>
                                <span className="ml-1">
                                <ShowProgressSpinner
                                    sizeClass={'w-5 h-5'}
                                    dataFetchInProgress={dataFetchInProgress}/>
                            </span>
                            </button>
                        </div>
                        <div className="ml-2">
                            <button
                                className="button-green px-4 py-2 flex items-center justify-center"
                                onClick={startProductsSyncProcess}>
                                <span>Start Products Sync Process</span>
                            </button>
                        </div>

                        <div className="ml-2">
                            <button
                                className="button-gray px-4 py-2 flex items-center justify-center"
                                onClick={getLatestBulkOperationStatus}>
                                <span>Get Latest Bulk Operation Status</span>
                            </button>
                        </div>
                    </div>

                </div>
            </div>

            <div className="flex justify-start">

                <div
                    className="shopify-bulk-operation-table-container w-full mt-4  overflow-y-scroll border-y border-gray-400 bg-white">

                    <ShowEmptyListMessage
                        dataList={bulkOperationsList}
                        dataFetchInProgress={dataFetchInProgress}
                        label={'Shopify Bulk Operations'}/>

                    {bulkOperationsList?.length > 0 &&
                        <table className="w-full">
                            <thead className="">
                            <tr>
                                <th className="p-2 border border-gray-400 sticky top-0 bg-gray-400 text-white">S.No</th>
                                {SHOPIFY_BULK_OPERATION_FIELDS_LIST?.map((bulkOperationField, rowIndex) => (
                                    <th key={`th-${rowIndex}`}
                                        className="p-2 border border-gray-400 sticky top-0 bg-gray-400 text-white">{bulkOperationField?.label}</th>
                                ))}
                                <th className="px-2 pb-2 border border-gray-400 sticky top-0 bg-gray-400 text-white">Action</th>
                            </tr>
                            </thead>
                            <tbody className="">
                            {bulkOperationsList?.map((bulkOperation, rowIndex) => (
                                <tr key={`row-${rowIndex}`} className="border border-gray-400">
                                    <td className="p-2 border border-gray-400 m-auto">
                                        <div className="flex justify-center">
                                            {rowIndex + 1}
                                        </div>
                                    </td>

                                    {SHOPIFY_BULK_OPERATION_FIELDS_LIST?.map((bulkOperationField, columnIndex) => (
                                        <React.Fragment key={`column-${rowIndex}-${columnIndex}`}>
                                            <td className="p-2 border border-gray-400 m-auto">

                                                {bulkOperationField?.attribute !== 'id' &&
                                                    <>{bulkOperation[bulkOperationField?.attribute]}</>
                                                }

                                            </td>
                                        </React.Fragment>
                                    ))}

                                    <td className="w-fit p-2 border border-gray-400 m-auto">
                                        <div className="flex justify-center items-center">
                                            <CopyDataToClipboard value={JSON.stringify(bulkOperation, null, 2)}/>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    }
                </div>

            </div>

        </>
    )
}

export default ShopifyBulkOperationList
